/* ============================================================
   BUNON — Cash on Delivery auto-trigger
   After a Bundle Builder confirm, the customer is redirected to
   /cart. If they came from a bundle, best-effort auto-open the
   Releasit "Buy with Cash on Delivery" button (#rsi_buy_now_button)
   so they don't have to find it themselves.

   This button is injected by a third-party app at runtime, so the
   selector/timing isn't guaranteed — this is a best-effort
   enhancement only. The /cart redirect itself (done by
   bunon-bundle.js before this ever runs) is the reliable baseline.
   ============================================================ */
(function () {
  'use strict';

  var FLAG_KEY = 'bunonBundleCod';
  var COD_SELECTOR = '#rsi_buy_now_button';
  var MAX_ATTEMPTS = 20;
  var POLL_MS = 300;

  var shouldTrigger = false;
  try { shouldTrigger = sessionStorage.getItem(FLAG_KEY) === '1'; } catch (e) {}
  if (!shouldTrigger) return;

  /* Clear immediately so a manual page reload on /cart doesn't re-trigger this. */
  try { sessionStorage.removeItem(FLAG_KEY); } catch (e) {}

  var attempts = 0;
  var timer = setInterval(function () {
    attempts += 1;
    var btn = document.querySelector(COD_SELECTOR);
    if (btn && btn.offsetParent !== null) {
      clearInterval(timer);
      btn.click();
      return;
    }
    if (attempts >= MAX_ATTEMPTS) {
      clearInterval(timer);
    }
  }, POLL_MS);
})();
